import React from 'react'
import Header from '../components/header/Header'
import Gesture from '../assets/gesture-recognition.jpg'
import Footer from '../components/footer/Footer'
import TitleText from '../utils/TitleText'
import Contact from '../components/contact/Contact'
import Description from '../components/description/description'
import { BiCheck } from 'react-icons/bi'
import HomeButton from '../components/homebutton/HomeButton'
const GestureRecognition = () => {
    const footitems=[
        {sec:'#',title:'Home'},
        {sec:'#description',title:'Description'},
        {sec:'#contact',title:'Contact'},

    ]
    TitleText('Gesture Recognition')
  return (
    <>
        <HomeButton/>
        <Header text1="" text2="Gesture Recognition" text3="" img={Gesture} />
        <Description title= 'Desciption' link ='https://github.com/Anmol23oct/Gesture-Recognition-using--SNN' data={
            <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Quantization of weights which helps reduce the memory requirements while also reducing the solution space and Scheduling of Learning rate which helps us avoid local minimas.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Performed the analysis based on Learning Rate Schedulers like, linear LR, Multi- step LR and Cosine LR. </p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>A Comparative analysis based on weight quantization comparing floating points, 8 bits and 4 bits weight values.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Tech Stack : Python, Pytorch, Seaborn, Scikit</p>
            </li>
    
          </ul>
        }/>
        <Contact/>
        <Footer footitems={footitems}/>
    </>
  )
}

export default GestureRecognition